module.exports = __webpack_public_path__ + "img/logo-with-name.dark.a90219b9.svg";